<template>
  <div id="contenedor-main-listado-eventos">
    <template v-if="!$vuetify.breakpoint.mobile">
      <desktop :licitacionEventos="licitacionEventos"></desktop>
    </template>
    <template v-else>
      <mobile :licitacionEventos="licitacionEventos"></mobile>
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoEventos',
  props: {
    licitacionEventos: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
</style>
